webpackJsonp([216651184406536],{

/***/ 1003:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0016_generals_hammer.jpg","type":"Spell","subtype":null,"cost":3,"ATK":null,"HP":null,"rules_text_1":"Deal 3 damage to a building.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"General's Hammer","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Blue","spec":"Peace","bottom":"Magic","rulings":[],"keywords":[],"slug":"generals_hammer"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"generals_hammer","keywords":[],"imageRegex":"/generals_hammer.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-generals-hammer-bcb453fd28a6d0d951e6.js